<template>
  <div class="ion-page">
    <ion-header class="rp-mobile">
      <ion-toolbar class="mobile-header-toolbar">
        <ion-buttons >
        <ion-menu-button></ion-menu-button>
        <ion-title>Notifications</ion-title>
        <ion-icon :icon="homeSharp" class="ion-margin ios" @click="homePage"></ion-icon>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-header class="rp-desktop">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button></ion-menu-button>
        </ion-buttons>
          <ion-title>Notifications</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <Notifications />
    </ion-content>
  </div>
</template>

<script>
import { defineComponent } from "vue";
// @ is an alias to /src
// import Notifications from "@/components/notifications/Notifications.vue";
import Notifications from "@/components/notification/Notifications.vue";
import { homeSharp } from "ionicons/icons";
import { IonButtons, IonContent, IonHeader, IonIcon, IonMenuButton, IonTitle, IonToolbar } from "@ionic/vue";

export default defineComponent ({
  name: 'notifications',
  components: {
    Notifications, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonIcon, IonContent
  },
  data() {
    return {
      homeSharp
    }
  },
  methods: {
    homePage() {
      this.$router.push("/customer/reservation")
    }
  }
})
</script>

<style scoped>
.ios ion-icon {
  color: white;
  position: relative;
  left:70%;
}
@media (max-width: 768px) {
  .mobile-header-toolbar {
    --background: #21b24b;
  }
  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }
  .mobile-header-toolbar ion-title {
    color: #fff;
  }
  .mobile-header-toolbar ion-buttons {
    color: #fff;
    --background: #fff;
  }
  .mobile-header-toolbar ion-menu-button {
    color: #fff !important;
    margin-right: 13px;
  }
}
</style>